module.exports = __webpack_public_path__ + "static/media/HomeEcobank.82693282.svg";